<template>
  <div>
    <span v-for="bid in bidList" v-bind:key="rand() + bid">
      <span
        v-if="bid.indexOf('H') > -1 || bid.indexOf('D') > -1"
        v-on:click="userSelectedBid = bid"
        class="tag is-small has-text-danger"
        v-bind:class="{
           'bid-selected': selectedBids.findIndex(b => b.bid == bid) > -1,
           'disabled': disabledList.indexOf(bid) > -1,
           'selected': userSelectedBid == bid}"
      >{{ bid | bidToString }}</span>
      <span
        v-else
        class="tag is-small"
        v-bind:class="{
          'bid-selected': selectedBids.findIndex(b => b.bid == bid) > -1,
          'disabled': disabledList.indexOf(bid) > -1,
           'selected': userSelectedBid == bid}"
        v-on:click="userSelectedBid = bid"
      >{{ bid | bidToString }}</span>
      <span v-if="bid.indexOf('NT') > -1">
        <br />
      </span>
    </span>
    <div class="level is-mobile mx-4">
      <button
        v-if="userPosition == currentPosition"
        class="button is-small is-link mt-1"
        style="height: 24px; font-weight: bold;"
        v-on:click="pass()"
      >PASS</button>
      <button
        v-if="userPosition == currentPosition"
        class="button is-small is-link mt-1"
        style="height: 24px; font-weight: bold;"
        v-bind:class="{'disabled': userSelectedBid == ''}"
        title="Select a bid above."
        v-on:click="setBid(userSelectedBid)"
      >SEND</button>
    </div>
  </div>
</template>

<script>
import socketStore from "@/service/socketStore";

export default {
  name: "BidBoxComponent",
  props: {
    userPosition: Number,
    currentPosition: Number,
    selectedBids: Array,
  },
  data: () => {
    return {
      bidList: [],
      userSelectedBid: "",
    };
  },
  computed: {
    disabledList: function () {
      // the items in between selected bids
      var disabled = [];
      if (this.selectedBids && this.selectedBids.length > 0) {
        for (var last = this.selectedBids.length - 1; last >= 0; last--) {
          var latestBid = this.selectedBids[last];
          if (latestBid.bid != "PASS") {
            break;
          }
        }
        var latestBidIndex = this.bidList.findIndex((b) => b == latestBid.bid);
        for (var i = 0; i < latestBidIndex; i++) {
          disabled.push(this.bidList[i]);
        }
      }
      return disabled;
    },
  },
  methods: {
    rand() {
      return Math.random().toString(36).substring(7);
    },
    populateBidList() {
      var suit = ["C", "D", "H", "S", "NT"];
      for (var i = 1; i <= 7; i++) {
        for (var j = 0; j < 5; j++) {
          this.bidList.push(i + suit[j]);
        }
      }
    },
    pass() {
      socketStore.emit("set_bid", "PASS");
    },
    setBid() {
      socketStore.emit("set_bid", this.userSelectedBid);
    },
  },
  mounted() {
    this.populateBidList();
  },
};
</script>

<style></style>
